import React from 'react';
// @ts-ignore
import {mkConfig, generateCsv, download} from 'export-to-csv';
import moment from 'moment';

interface CsvExportButtonProps {
  table: any;
  filename: string;
  label?: string;
}

export const CsvExportButton: React.FC<CsvExportButtonProps> = ({
  table,
  filename,
  label = 'Export CSV',
}) => {
  const generatedFilename = `${filename}_${moment().format('YYYY-MM-DD_HH-mm')}`;

  const csvConfig = mkConfig({
    filename: generatedFilename,
    fieldSeparator: ',',
    decimalSeparator: '.',
    useBom: true,
    showLabels: true,
    useKeysAsHeaders: true,
  });

  const handleExport = () => {
    const exportData = table.getPrePaginationRowModel().rows.map((r) =>
      r.getAllCells().reduce((acc, cell) => {
        acc[cell.column.id] = cell.getValue();
        return acc;
      }, {}),
    );

    const csv = generateCsv(csvConfig)(exportData);
    download(csvConfig)(csv);
  };

  return (
    <button className="btn btn-primary" onClick={handleExport}>
      {label}
    </button>
  );
};
